// extracted by mini-css-extract-plugin
export default {"btn":"BiddingButton_btn__-r0Mw","shadow":"BiddingButton_shadow__-jS2B","disabled":"BiddingButton_disabled__eeKS3","modal":"BiddingButton_modal__3bmu9"};